import EmpresaService from '@/service/EmpresaService'

export default {
  namespaced: true,
  state: {
    links: [],
  },
  getters: {
    links(state) {
      return state.links
    },
  },
  mutations: {
    UPDATE_LINKS(state, links) {
      state.links = links
    },
  },
  actions: {
    async findAll({ commit }) {
      const links = await EmpresaService.findLinks()
      commit('UPDATE_LINKS', links)
      return links
    },
  },
}